import React from "react";
import styles from "./LoginButton.css";
import Spinner from "./Spinner";

var LoginButton = ({isActive, buttonText, style, loading, loaded}) =>
  (
    <button id="loginbutton" className={style} type="submit" disabled={loading}>
      <a>{!loading ? buttonText : <Spinner className={styles.spinner} loaded={loaded}></Spinner>}</a>
    </button>
  )

export default LoginButton



// WEBPACK FOOTER //
// ./src/html-components/LoginButton.jsx